import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IHomeState {
    isSubmitting: boolean;
    openImportModal: boolean;
}

const initialState: IHomeState = {
    isSubmitting: false,
    openImportModal: false,
};

export const homeSlice = createSlice({
    name: "home",
    initialState: initialState,
    reducers: {
        setIsSubmitting: (state, action: PayloadAction<boolean>) => {
            state.isSubmitting = action.payload;
        },
        setOpenImportModal: (state, action: PayloadAction<boolean>) => {
            state.openImportModal = action.payload;
        },
    },
});

export const { setIsSubmitting, setOpenImportModal } = homeSlice.actions;

export default homeSlice.reducer;
